
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Create Customer Fleet</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <form #createCustomerForm="ngForm">
        <div class="row">
          <div class="form-group col-6">
            <label class="required" for="customerName">Customer Name:</label>
            <input class="form-control" id="customerName" name="mame" type="text" [(ngModel)]="customer.name">
          </div>
          <div class="form-group col-6">
            <label class="required" for="billDestination">Billing Destination:</label>
            <select class="form-control" [(ngModel)]="customer.billDestination" name="billDestination" maxlength="100" required>
              <option value=""></option>
              <option *ngFor="let destination of billingDestinations" [ngValue]="destination.key">{{ destination.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="required" for="contractNumber">Contract Number:</label>
            <input class="form-control" id="contactNumber" name="contractNumber" type="text" [(ngModel)]="customer.contractNumber">
          </div>
          <div class="form-group col-6">
            <label class="required" for="pricingModel">Pricing Model:</label>
            <select class="form-control" [(ngModel)]="customer.pricingModel" name="pricingModel" maxlength="100" required>
              <option value=""></option>
              <option *ngFor="let pricingModel of pricingModels" [ngValue]="pricingModel.key">{{ pricingModel.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="customHeading1">Custom Heading 1:</label>
            <input class="form-control" id="customHeading1" name="customHeading1" type="text" [(ngModel)]="customer.customHeading1">
          </div>
          <div class="form-group col-6">
            <label for="customHeading2">Custom Heading 2:</label>
            <input class="form-control" id="customHeading2" name="customHeading2" type="text" [(ngModel)]="customer.customHeading2">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="customHeading3">Custom Heading 3:</label>
            <input class="form-control" id="customHeading3" name="customHeading3" type="text" [(ngModel)]="customer.customHeading3">
          </div>
          <div class="form-group col-6">
            <label for="customHeading4">Custom Heading 4:</label>
            <input class="form-control" id="customHeading4" name="customHeading4" type="text" [(ngModel)]="customer.customHeading4">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="customHeading5">Custom Heading 5:</label>
            <input class="form-control" id="customHeading5" name="customHeading5" type="text" [(ngModel)]="customer.customHeading5">
          </div>
          <div class="form-group col-6">
            <div class="form-check">
              <input class="form-check-input" name="billingActive" type="checkbox" [(ngModel)]="customer.billingActive">
              <label class="form-check-label">Active Billing</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" name="custAllSapServer" type="checkbox" [(ngModel)]="customer.custAllSapServer">
              <label class="form-check-label">Cust All SAP Server</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h4>Default flags for new area &amp; groups</h4>
          </div>
          <div class="form-group col-12">
            <div class="form-check">
              <input class="form-check-input" name="doUsageCollection" type="checkbox" [(ngModel)]="customer.doUsageCollection">
              <label class="form-check-label">Enable Usage</label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" title="Cancel" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" type="button" title="Save changes" (click)="createCustomerFleet()">&nbsp;&nbsp;Save&nbsp;&nbsp;</button>
    </div>
  </div>
</div>